<template>
  <router-link :to="'/apn/' + item.id" class="link">
  <tr class="apt_item__wrap pointer">
    <td class="w100" :data-label="translate('apn_list.status')">
      <span v-if="item.is_active" class="mdi mdi-check-circle-outline" />
      <span v-else class="mdi mdi-close-circle" />
    </td>

    <td class="w100" :data-label="translate('apn_list.devices')">
      {{ item.device_count }}
    </td>

    <td class="w100" :data-label="translate('apn_list.mno_name')">
      {{ item.mno_name }}
    </td>

    <td class="text-bold" :data-label="translate('apn_list.apn')">
      {{ item.apn }}
      <span class="mdi mdi-content-copy pointer" @click.prevent.stop="copy_apn(item.apn)" />
    </td>

    <td class="" :data-label="translate('apn_list.oper_account')">
      <template v-for="oper_account in item.oper_accounts">
        {{ oper_account.oper_account }}
      </template>
    </td>

    <td class="" :data-label="translate('apn_list.network_access_type')">
      {{ item.network_access_type }}
    </td>

    <td class="" :data-label="translate('apn_list.device_apn_mode')">
      {{ item.device_apn_mode }}
    </td>

    <td class="" :data-label="translate('apn_list.ip_networks')">
      {{ item.ip_networks }}
    </td>

    <td class="" :data-label="translate('apn_list.provisioning_mode')">
      {{ item.provisioning_mode }}
    </td>


    <td :data-label="translate('apn_list.client_names')">
      <p v-for="(client, key) in item.client_names" :key="key" class="client">
        {{ client }}
      </p>
    </td>

    <td class="" :data-label="translate('apn_list.comment')">
      <pre v-if="item.comment" v-text="item.comment" class="limit-pre"></pre>
      <span v-else></span>
    </td>

    <td class="" :data-label="translate('apn_list.params')">
      <pre v-if="item.params" v-text="item.params" class="limit-pre"></pre>
      <span v-else></span>
    </td>

    <td class="" :data-label="translate('apn_list.ts_create')" v-html="get_date_any_lines(item.ts_create, null, 2)"></td>
  </tr>
  </router-link>
</template>
<script>



export default {
  name: 'ApnListItem',
  components: {
  },
  props: ['item'],
  data () {
    return {
    }
  },

  methods:{
    copy_apn(string){
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },

  }
}
</script>

<style lang="scss" scoped>
  .apt_item{
    &__wrap{
      font-size: 12px;
      &:hover{
        background-color: #eee;
      }
      .mdi{
        font-size: 20px;
      }
      pre{
        text-align: left;
        font-size: 12px;
        margin: 0;
      }
      .client{
        font-size: 12px;
        margin: 0;
      }
      .text-bold{
        font-weight: bold;
        vertical-align: middle;
        .mdi{
          font-size: 16px;
        }
      }
      .limit-pre {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;

        white-space: pre-line;
        line-height: 18px;
        max-height: 54px;
      }
    }
  }
</style>
